module.exports = __webpack_public_path__ + "static/media/dhara (2).6ccb8894.png";